import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import { HeatMapGrid } from "react-grid-heatmap";
import HeatmapVisual from "./HeatMapVisual";

function HeatMapChart() {
  const { fetchOnlyData } = SupervisorApi();
  const [timeRange, setTimeRange] = useState(0);
  const [newPeriod, setNewPeriod] = useState("7days");

  const [xLabels, setXLabels] = useState([]);
  const [yLabels, setYLabels] = useState([]);
  const [dataMatrix, setDataMatrix] = useState([]);
  const [colorMatrix, setColorMatrix] = useState([]);
  const [yLabelsStyleMap, setYLabelsStyleMap] = useState({});

  const period = [
    { id: 0, key: "7days", time: "One Week" },
    { id: 1, key: "30days", time: "One Month" },
    { id: 2, key: "12months", time: "One Year" },
  ];

  useEffect(() => {
    const selected = period[timeRange];
    if (selected) {
      setNewPeriod(selected.key);
    }
  }, [timeRange]);

  const chartData = useMutation({
    mutationFn: () =>
      fetchOnlyData(`dashboard/heat-map?date_filter=${newPeriod}`, null, true),
  });

  useEffect(() => {
    chartData.mutate();
  }, [newPeriod]);

  useEffect(() => {
    console.log(chartData.data);
  }, [chartData]);

  return (
    <div className="mb-6 w-full overflow-x-auto">
      <div className="flex justify-between items-center">
        <h3 className="text-3xl font-semibold mb-4">Stock Heat Map</h3>
        {/* <HeatmapVisual data={chartData?.data} /> */}
      </div>
    </div>
  );
}

export default HeatMapChart;
